import { render, staticRenderFns } from "./Alarm.vue?vue&type=template&id=d873978a&scoped=true"
import script from "./Alarm.vue?vue&type=script&lang=js"
export * from "./Alarm.vue?vue&type=script&lang=js"
import style0 from "./Alarm.vue?vue&type=style&index=0&id=d873978a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d873978a",
  null
  
)

export default component.exports